// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.strip-button-blood, .strip-button-blood:hover, .strip-button-blood:disabled, .strip-button-blood:hover:disabled, .strip-button-blood:focus, .strip-button-blood:visited {
	background-color: #03112c !important;
	border-color: rgba(0, 0, 0, 0) !important;
	border-width: 0 !important;
	height: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/bloodviewer/blood_viewer.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;CACpC,yCAAyC;CACzC,0BAA0B;CAC1B,uBAAuB;AACxB","sourcesContent":[".strip-button-blood, .strip-button-blood:hover, .strip-button-blood:disabled, .strip-button-blood:hover:disabled, .strip-button-blood:focus, .strip-button-blood:visited {\n\tbackground-color: #03112c !important;\n\tborder-color: rgba(0, 0, 0, 0) !important;\n\tborder-width: 0 !important;\n\theight: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
